module.exports = __webpack_public_path__ + "img/ANTENNA 4 RED.2078a89.svg";